import { useState } from "react";
import {
  selectLocalPeerName,
  useHMSActions,
  useHMSStore,
} from "@100mslive/react-sdk";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { usePreviewPreferences } from "@/hooks/usePreferences";

export const ChangeNameDialog = ({ open, onOpenChange }) => {
  const hmsActions = useHMSActions();
  const currentName = useHMSStore(selectLocalPeerName) || "";
  const [name, setName] = useState(currentName);
  const [saving, setSaving] = useState(false);
  const [preferences, setPreferences] = usePreviewPreferences();
  const trimmed = name.trim();
  const canSave = Boolean(trimmed) && trimmed !== currentName && !saving;

  const save = async event => {
    event.preventDefault();
    if (!canSave) {
      return;
    }
    setSaving(true);
    try {
      await hmsActions.changeName(trimmed);
      setPreferences({ ...preferences, name: trimmed });
      onOpenChange(false);
    } catch (error) {
      toast.error("Your name could not be changed", {
        description: error?.message,
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-sm">
        <form onSubmit={save} className="grid gap-4">
          <DialogHeader>
            <DialogTitle>Change your name</DialogTitle>
          </DialogHeader>
          <div className="grid gap-2">
            <Label htmlFor="change-name">Name</Label>
            <Input
              id="change-name"
              autoFocus
              autoComplete="name"
              value={name}
              onChange={event => setName(event.target.value)}
              data-testid="change_name_field"
            />
          </div>
          <DialogFooter>
            <DialogClose asChild>
              <Button type="button" variant="outline">
                Cancel
              </Button>
            </DialogClose>
            <Button
              type="submit"
              disabled={!canSave}
              data-testid="popup_change_btn"
            >
              Change
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
